/**
 * Collections of the open API workspace: `collections:` / `col:` / `collection:`. Desktop only.
 * Backed by the local search index (PLAN §12.2) through `deps.client`
 * (`index/indexClient.js` on desktop, `index/webIndexClient.js` on web).
 */
import { Layers } from 'lucide-react';
import { createIndexProvider } from '../index/indexProvider';

export const SPEC = Object.freeze({ id: 'collections', kinds: ['collection'], prefixes: ['collections', 'col', 'collection'], labelKey: 'palette.scope.collections', icon: Layers, order: 90, page: 'collections', desktopOnly: true, workspaceScoped: true, apiClient: true });

/** @param {{ client: object }} deps */
export default function create(deps) {
  return createIndexProvider(SPEC, deps);
}
